var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"remove-favorite-btn",on:{"mouseenter":_vm.toggleHover,"mouseleave":_vm.toggleHover,"click":_vm.removeGoal}},[_c('i',{staticClass:"fa fa-lg fa-times",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }